import { getCookie } from '../CookieUtil';

class EgClickstreamEventTemplates {
    static instance;

    static marketingProperties() {
        // eslint-disable-next-line no-restricted-globals
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop)
        });
        if (
            params.utm_id
          || params.utm_source
          || params.utm_medium
          || params.utm_campaign
          || params.utm_term
          || params.utm_content
        ) {
            return {
                marketing: {
                    marketing_entry_bool: !!params.utm_id,
                    same_session_marketing_code: `Id=${params.utm_id};source=${params.utm_source};medium=${params.utm_medium};name=${params.utm_campaign};term=${params.utm_term};content=${params.utm_content}`,
                    same_session_marketing_keywords: params.utm_term
                }
            };
        }
        return {};
    }

    static addEpcDuaid() {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop)
        });
        if (params.epc_duaid) {
            return {
                trace_id_of_the_view: params.epc_duaid
            };
        }
        return {};
    }

    static getInstance() {
        if (!this.instance) {
            const {
                appName,
                brand,
                publicUuid
            } = window.egClickstreamdatalayer;
            this.instance = {
                event: {
                    event_category: `tpg.${appName}`
                },
                user: {
                    brand_customer_id: String(publicUuid)
                },
                identifiers: {
                    ...this.addEpcDuaid()
                },
                experience: {
                    app_name: appName,
                    app_version: '1.0.0'
                },
                point_of_sale: {
                    eg_brand_name: 'Partner Central',
                    sub_brand_name: brand
                },
                ...this.marketingProperties()
            };
        }
        return this.instance;
    }

    static setUserId(userId) {
        if (!this.instance) this.getInstance();
        this.instance.user.brand_customer_id = String(userId);
    }

    static getSession() {
        const session = getCookie('has');
        return session || getCookie('ulxsession');
    }

    static updateSessionId() {
        if (!this.instance) this.getInstance();
        this.instance.identifiers.session_id = this.getSession();
    }

    static createCustomEvent(customFields, event) {
        const safeEvent = event;
        if (safeEvent.marketing) {
            delete safeEvent.marketing;
        }
        return {
            ...safeEvent,
            ...customFields
        };
    }

    static createEvent({ experience, event }, userId = false) {
        if (userId) this.setUserId(userId);
        this.updateSessionId();
        const obj = this.getInstance();
        return {
            ...obj,
            experience: {
                ...obj.experience,
                ...experience
            },
            event: {
                ...obj.event,
                ...event
            }
        };
    }
}

export default EgClickstreamEventTemplates;
